import { Reducer } from "react";
import { getType } from "typesafe-actions";
import { MutationState } from "../types";
import { STORAGE_AUTH_TOKEN } from "./../../../constants/storage";
import { User } from "./../../models/users";
import {
  createUserAsync,
  createUserClear,
  fetchSelfAsync,
  loginAsync,
  loginClear,
  setAuthToken,
} from "./actions";
import { UserAction } from "./types";

type UserState = {
  create: MutationState<string>;
  login: MutationState<string>;

  authToken?: string;

  loading: boolean;
  initialized: boolean;
  user?: User;
};

const initialUserState: UserState = {
  loading: false,
  initialized: false,

  login: { loading: false },
  create: { loading: false },
};

const userReducer: Reducer<UserState, UserAction> = (
  state: UserState = initialUserState,
  action: UserAction
) => {
  switch (action.type) {
    case getType(setAuthToken): {
      return { ...state, authToken: action.payload };
    }

    case getType(loginAsync.request): {
      return { ...state, login: { loading: true } };
    }
    case getType(loginAsync.success): {
      const {
        payload: { access },
      } = action;
      localStorage.setItem(STORAGE_AUTH_TOKEN, access);
      return {
        ...state,
        authToken: access,
        login: { loading: false, item: access },
      };
    }
    case getType(loginAsync.failure): {
      return { ...state, login: { loading: false, error: action.payload } };
    }
    case getType(loginClear): {
      return {
        ...state,
        login: { loading: false },
      };
    }

    case getType(createUserAsync.request): {
      return {
        ...state,
        create: { loading: true },
      };
    }
    case getType(createUserAsync.success): {
      const {
        payload: { access },
      } = action;
      localStorage.setItem(STORAGE_AUTH_TOKEN, access);
      return {
        ...state,
        authToken: access,
        create: { loading: false, item: access },
      };
    }
    case getType(createUserAsync.failure): {
      return {
        ...state,
        create: { loading: false, error: action.payload },
      };
    }
    case getType(createUserClear): {
      return {
        ...state,
        create: { loading: false },
      };
    }

    case getType(fetchSelfAsync.request): {
      return { ...state, loading: true };
    }
    case getType(fetchSelfAsync.success): {
      const user = new User(action.payload);
      return { ...state, loading: false, initialized: true, user };
    }
    case getType(fetchSelfAsync.failure): {
      return { ...state, loading: false };
    }

    default:
      return state;
  }
};

export default userReducer;
